import { Component } from '@angular/core';
import { CookieOptions, CookieService } from 'ngx-cookie-service';

export enum CookieStorageKey {
  CONSENT = 'COOKIE-CONSENT'
}

export enum CookieStorageValue {
  AGREED = 'AGREED',
  DISAGREED = 'DISAGREED'
}

const CONSENT_EXPIRATION_DAYS = 398;

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
})
export class CookieConsentComponent {
  consentAccepted = false

  constructor(private readonly cookieService: CookieService) {
    const agreedValue: CookieStorageValue = this.cookieService.get(CookieStorageKey.CONSENT) as CookieStorageValue;

    if (agreedValue === CookieStorageValue.AGREED) {
      this.consentAccepted = true;
    }
  }

  onAccept() {
    this.consentAccepted = true;

    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + CONSENT_EXPIRATION_DAYS);

    this.cookieService.set(CookieStorageKey.CONSENT, CookieStorageValue.AGREED, expirationDate);
  }
}
